import { render, staticRenderFns } from "./VListVouchers.vue?vue&type=template&id=70666434&"
import script from "./VListVouchers.vue?vue&type=script&lang=js&"
export * from "./VListVouchers.vue?vue&type=script&lang=js&"
import style0 from "./VListVouchers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports